<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">{{ 'CLIENT.INFORMATION_LABEL' | translate }}</h4>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="clientForm" (ngSubmit)="updateClient()">
                            <div class="row">
                                <div class="col-md-5">
                                    <mat-label>{{ 'CLIENT.LASTNAME_LABEL' | translate }} *</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="lastName"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.lastName?.errors?.required">
                                            {{ 'CLIENT.LASTNAME_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-5">
                                    <mat-label>{{ 'CLIENT.FIRSTNAME_LABEL' | translate }} *</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="firstName"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.firstName?.errors?.required">
                                            {{ 'CLIENT.FIRSTNAME_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'CLIENT.SPONSORSHIP_CODE_LABEL' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="sponsorshipCode" disabled type="text">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <mat-label>{{ 'CLIENT.EMAIL_LABEL' | translate }} *</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="email" [errorStateMatcher]="matcher"
                                               type="text">
                                        <mat-error
                                                *ngIf="getControl?.email?.errors?.email">
                                            {{ 'CLIENT.EMAIL_FORMAT_ERROR_LABEL' | translate }}
                                        </mat-error>
                                        <mat-error *ngIf="getControl?.email?.errors?.required">
                                            {{ 'CLIENT.EMAIL_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'CLIENT.PHONE_NUMBER' | translate }} *</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="phoneNumber"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.phoneNumber?.errors?.required">
                                            {{ 'CLIENT.PHONE_NUMBER_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                                        </mat-error>
                                        <mat-error *ngIf="getControl?.phoneNumber?.errors?.pattern">
                                            {{ 'CLIENT.PHONE_NUMBER_FORMAT_ERROR_LABEL' | translate }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'CLIENT.CREATION_DATE_LABEL' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput [matDatepicker]="creationDatePicker"
                                               formControlName="creationDate" [errorStateMatcher]="matcher">
                                        <mat-datepicker-toggle matSuffix
                                                               [for]="creationDatePicker"></mat-datepicker-toggle>
                                        <mat-datepicker #creationDatePicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'CLIENT.BIRTH_DATE_LABEL' | translate }} *</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput [matDatepicker]="birthDatePicker"
                                               formControlName="birthDate" [errorStateMatcher]="matcher">
                                        <mat-datepicker-toggle matSuffix
                                                               [for]="birthDatePicker"></mat-datepicker-toggle>
                                        <mat-datepicker #birthDatePicker></mat-datepicker>
                                        <mat-error *ngIf="getControl?.birthDate?.errors?.required">
                                            {{ 'CLIENT.BIRTH_DATE_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'CLIENT.ZIPCODE_LABEL' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="zipCode"
                                               type="text">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <mat-label class="mr-5">{{ 'CLIENT.PREFERENCES_LABEL' | translate }}</mat-label>
                                    <p-multiSelect [options]="allPreferences" formControlName="preference"
                                                   optionLabel="displayedValue" display="chip"></p-multiSelect>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-1">
                                    <div class="example-full-width mt-4">
                                        {{'CLIENT.SEXE_LABEL' | translate }}
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="example-full-width">
                                        <i (click)="setGender('male')" class="sexe fa fa-male"
                                           [style.border]="isMale? 'black solid 1px':''"></i>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="example-full-width">
                                        <i (click)="setGender('other')" class="sexe fa fa-transgender"
                                           [style.border]="isOther? 'black solid 1px':''"></i>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="example-full-width">
                                        <i (click)="setGender('female')" class="sexe fa fa-female"
                                           [style.border]="isFemale? 'black solid 1px':''"></i>
                                    </div>
                                </div>
                            </div>

                            <button mat-raised-button type="submit"
                                    class="btn btn-danger pull-right">{{ 'BUTTONS.SAVE' | translate }}
                            </button>
                            <div class="clearfix"></div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">{{ 'CLIENT.CLIENTS_SPONSORED_LABEL' | translate }}</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <p-table #dt [value]="client.referredClient" [rows]="10" [paginator]="true">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>{{ 'CLIENT.LASTNAME_LABEL' | translate }}
                                            </th>
                                            <th>{{ 'CLIENT.SPONSORED_DATE_LABEL' | translate }}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-refClient>
                                        <tr>
                                            <td>{{refClient.firstName}} {{refClient.lastName}}</td>
                                            <td>{{refClient?.creationDate | date: 'dd/MM/yyyy'}}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>

